<template>
    <svg width="2" height="8" viewBox="0 0 2 8" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g clip-path="url(#clip0_2_7)">
            <path d="M1 2C1.55228 2 2 1.55228 2 1C2 0.447715 1.55228 0 1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2Z" fill="#515C69"/>
            <path d="M2 4C2 3.44772 1.55228 3 1 3C0.447715 3 0 3.44772 0 4V7C0 7.55228 0.447715 8 1 8C1.55228 8 2 7.55228 2 7V4Z" fill="#515C69"/>
        </g>
        <defs>
            <clipPath id="clip0_2_7">
                <rect width="2" height="8" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconUnionReverse',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
